import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { GeneralSettingsComponent } from '../general-settings/general-settings.component';
import { ArcangelSettingsComponent } from '../arcangel-settings/arcangel-settings.component';
import { AlertsSettingsComponent } from '../alerts-settings/alerts-settings.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'; // <-- Add this import

@Component({
  selector: 'app-settings-dialog',
  standalone: true,
  imports: [FormsModule, GeneralSettingsComponent, AlertsSettingsComponent, ArcangelSettingsComponent],
  templateUrl: './settings-dialog.component.html',
  styleUrl: './settings-dialog.component.css'
})
export class SettingsDialogComponent {
  viewTab: string = 'tab-about';
  version: string = '1.0.0';
  plugins: string[] = [
    'Plugin 1',
    'Plugin 2',
    'Plugin 3'
  ];

  constructor(public activeModal: NgbActiveModal) { } // <-- Inject here

  changeTab(tab: string): void {
    const tabs = ['tab-about', 'tab-general', 'tab-arcangel', 'tab-alerts'];
    this.viewTab = tab;
  }

  close(): void {
    this.activeModal.close();
  }
}